import { render } from "./_MaintenanceRole.vue?vue&type=template&id=b8b23e4a"
import script from "./_MaintenanceRole.vue?vue&type=script&lang=js"
export * from "./_MaintenanceRole.vue?vue&type=script&lang=js"

import exportComponent from "C:\\AgentPools\\FAOAgentPool\\_work\\32\\s\\WEPTW_Web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__